(function () {
  class MusicManager extends PIXI.Container {
    constructor() {
      super();

      this._baseID = [];
      this._baseMusic = [
        {
          sound: "baseThemeLevel0",
          volume: 1,
        },
        {
          sound: "baseThemeLevel1",
          volume: 1,
        },
        {
          sound: "baseThemeLevel2",
          volume: 0.9,
        },
        {
          sound: "baseThemeLevel3",
          volume: 0.9,
        },
      ];

      this._freeSpinsID = [];
      this._freeSpinsMusic = [
        {
          sound: "freeSpinsThemeLevel1",
          volume: 0.9,
        },
        {
          sound: "freeSpinsThemeLevel2",
          volume: 0.7,
        },
        {
          sound: "freeSpinsThemeLevel3",
          volume: 0.75,
        },
      ];

      this._stormLinkID = [];
      this._stormLinkMusic = [
        {
          sound: "stormLinkThemeLevel1",
          volume: 1,
        },
        {
          sound: "stormLinkThemeLevel2",
          volume: 0.95,
        },
        {
          sound: "stormLinkThemeLevel3",
          volume: 0.65,
        },
      ];

      this._popupMusic = undefined;

      this._fadeBaseTimeIn = 2;
      this._fadeBaseTimeOut = 3;

      this._lowerVolume = 0.3;

      this._currentLevel = 0;

      messageBus.subscribe(
        "sounds:restorePreviouslyPlayingAudio",
        this.onRestorePreviouslyPlayingAudio.bind(this)
      );
    }

    ///////////////////////////////////////////////
    setUpSounds() {
      for (var i = 0; i < this._baseMusic.length; i++) {
        this._baseID.push(soundManager.play(this._baseMusic[i].sound));
        soundManager.setVolume(0, this._baseID[i]);
      }

      for (var j = 0; j < this._freeSpinsMusic.length; j++) {
        this._freeSpinsID.push(
          soundManager.play(this._freeSpinsMusic[j].sound)
        );
        soundManager.setVolume(0, this._freeSpinsID[j]);
      }

      for (var k = 0; k < this._stormLinkMusic.length; k++) {
        this._stormLinkID.push(
          soundManager.play(this._stormLinkMusic[k].sound)
        );
        soundManager.setVolume(0, this._stormLinkID[k]);
      }

      this._popupMusic = soundManager.play("freeSpinsPopupTheme");
      soundManager.setVolume(0, this._popupMusic);

      this.fadeLevels(0, "base");
    }

    onRestorePreviouslyPlayingAudio(data) {
      if (data.reason === "back from replay" && !Reflex.replayGame) {
        this._baseID = [];
        this._freeSpinsID = [];
        this._stormLinkID = [];
        this.setUpSounds();
      }
    }

    getMaxVolume(index, listType) {
      let list;

      switch (listType) {
        case "base":
          list = this._baseMusic;
          break;

        case "freeSpins":
          list = this._freeSpinsMusic;
          break;

        case "stormLink":
          list = this._stormLinkMusic;
          break;
      }

      return list[index].volume;
    }

    fadeLevels(
      level,
      listType,
      fadeInTime = this._fadeBaseTimeIn,
      fadeOutTime = this._fadeBaseTimeOut
    ) {
      let list;

      switch (listType) {
        case "base":
          list = this._baseID;
          break;

        case "freeSpins":
          list = this._freeSpinsID;
          break;

        case "stormLink":
          list = this._stormLinkID;
          break;
      }

      let soundsToFadeOut = [];
      let soundToFadeIn = list[level];

      for (var i = 0; i < list.length; i++) {
        if (i === level) {
          continue;
        }

        soundsToFadeOut.push(list[i]);
      }

      const volume = this.getMaxVolume(level, listType);
      soundManager.fade(volume, fadeInTime, soundToFadeIn);

      for (var i = 0; i < soundsToFadeOut.length; i++) {
        soundManager.fade(0, fadeOutTime, soundsToFadeOut[i]);
      }

      this._currentLevel = level;
    }

    getMusicLevel() {
      return this._currentLevel;
    }

    increaseLevel(listType) {
      let limit;

      switch (listType) {
        case "base":
          limit = this._baseMusic.length - 1;
          break;

        case "freeSpins":
          limit = this._freeSpinsMusic.length - 1;
          break;

        case "stormLink":
          limit = this._stormLinkMusic.length - 1;
          break;
      }

      let newLevel = Math.min(this._currentLevel + 1, limit);

      if (this._currentLevel !== newLevel) {
        this._currentLevel = newLevel;

        this.fadeLevels(this._currentLevel, listType);
      }
    }

    fadeBaseMusicOff(time = this._fadeBaseTimeOut) {
      for (let i = 0; i < this._baseID.length; i++) {
        soundManager.fade(0, time, this._baseID[i]);
      }
    }

    fadeFreeSpinsMusicOff(time = this._fadeBaseTimeOut) {
      for (let i = 0; i < this._freeSpinsID.length; i++) {
        soundManager.fade(0, time, this._freeSpinsID[i]);
      }
    }

    fadeStormLinkMusicOff(time = this._fadeBaseTimeOut) {
      for (let i = 0; i < this._stormLinkID.length; i++) {
        soundManager.fade(0, time, this._stormLinkID[i]);
      }
    }

    setIdleMusic() {
      this._currentLevel = 0;

      this.fadeLevels(this._currentLevel, "base");

      this.fadeFreeSpinsMusicOff();
      this.fadeStormLinkMusicOff();
    }

    fadeOutAllMusic(time = this._fadeBaseTimeOut) {
      this.fadeBaseMusicOff(time);
      this.fadeFreeSpinsMusicOff(time);
      this.fadeStormLinkMusicOff(time);
    }

    fadeInPopUpMusic(time = 5) {
      soundManager.fade(1, time, this._popupMusic);
    }

    fadeOutPopUpMusic(time = 1) {
      soundManager.fade(0, time, this._popupMusic);
    }

    lowerFreeSpinsVolume() {
      for (let i = 0; i < this._stormLinkID.length; i++) {
        soundManager.fade(this._lowerVolume, 1, this._stormLinkID[i]);
      }
    }

    startCountUp() {
      soundManager.play("countUpLoop");
    }

    endCountUp() {
      soundManager.stop("countUpLoop");
      soundManager.play("countUpLoopEnd");
    }

    startPotBonusCountUp() {
      soundManager.play("potBonusCountUpLoop");
    }

    endPotBonusCountUp() {
      soundManager.stop("potBonusCountUpLoop");
      soundManager.play("potBonusCountUpLoopEnd");
    }

    startBigWin() {
      soundManager.play("bigWinLoop");
    }

    endBigWin() {
      soundManager.stop("bigWinLoop");
      soundManager.play("bigWinLoopEnd");
    }
  }

  ///////////////////////////////////////////////
  let musicManagerCreator = function (json) {
    return new MusicManager();
  };

  ///////////////////////////////////////////////
  let musicManagerInitialiser = function (json, obj) {};

  ///////////////////////////////////////////////
  let musicManagerFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "MusicManager",
    musicManagerCreator,
    musicManagerInitialiser,
    musicManagerFilesRequired
  );
})();
